module.exports = __webpack_public_path__ + "img/ic_support.36d34ce7.svg";